import { ref } from 'vue'

export const lastRoute = ref('/')
